import { Image } from "expo-image";
import { Link } from "expo-router";
import { Linking, Platform, ScrollView, StyleSheet, View } from "react-native";

import { GText } from "@/components/g-text";

const TEXT_COLOR = "#FEF7F3";

export default function TermsPage() {
  if (Platform.OS !== "web") {
    return (
      <View style={styles.nativeContainer}>
        <GText style={styles.nativeText}>terms of service</GText>
      </View>
    );
  }

  return (
    <ScrollView
      contentContainerStyle={styles.scrollContent}
      style={styles.container}
    >
      <View style={styles.main}>
        <View style={styles.logoContainer}>
          <Link href="/">
            <Image
              contentFit="contain"
              source={require("../../assets/logo.svg")}
              style={styles.logo}
            />
          </Link>
        </View>

        <GText style={styles.h1}>terms</GText>

        <GText style={styles.paragraph}>
          by using our app, you agree to these terms of service. please read
          carefully as these terms outline your rights and obligations when
          using aglow.
        </GText>

        <GText style={styles.h2}>1. account responsibility</GText>
        <GText style={styles.paragraph}>
          you are responsible for maintaining the confidentiality of your
          account information and for any activities that occur under your
          account. do not share your login information. if you suspect
          unauthorized use of your account, notify us immediately.
        </GText>

        <GText style={styles.h2}>2. content ownership and rights</GText>
        <GText style={styles.paragraph}>
          you own any content you create and post within aglow. by posting, you
          grant us a worldwide, non-exclusive, royalty-free, perpetual,
          irrevocable, and sublicensable right to use, display, modify, adapt,
          and promote your content solely within the app and for promotional
          purposes. we will not sell your content to third parties. no harmful,
          illegal, offensive, or infringing content is allowed. we reserve the
          right to remove content that violates these terms or applicable laws.
        </GText>

        <GText style={styles.h2}>3. community conduct</GText>
        <GText style={styles.paragraph}>
          be respectful to others. any form of harassment, bullying, hate
          speech, spamming, or abusive behavior is prohibited and will result in
          account suspension or termination. violations will be handled on a
          case-by-case basis, and users will have the right to appeal
          disciplinary actions.
        </GText>

        <GText style={styles.h2}>4. privacy and data use</GText>
        <GText style={styles.paragraph}>
          we respect your privacy and are committed to protecting your personal
          information. please review our{" "}
          <Link href="/privacy" style={styles.link}>
            <GText style={styles.link}>privacy policy</GText>
          </Link>{" "}
          to understand how we collect, use, and safeguard your data. by using
          aglow, you consent to the practices described in the privacy policy.
        </GText>

        <GText style={styles.h2}>5. sms messaging</GText>
        <GText style={styles.paragraph}>
          by providing your phone number and opting in, you consent to receive
          SMS text messages from aglow related to event information, ticketing,
          and account notifications. message types may include event reminders,
          ticket confirmations, event updates, and account verification codes.
        </GText>
        <GText style={styles.paragraph}>
          message frequency varies based on your event activity. message and
          data rates may apply depending on your mobile carrier plan. you can
          opt out of receiving SMS messages at any time by replying STOP to any
          message. after opting out, you will receive a confirmation message and
          no further SMS messages will be sent unless you re-subscribe. for
          help, reply HELP to any message or contact us at{" "}
          <GText
            onPress={() => Linking.openURL("mailto:support@aglow.app")}
            style={styles.link}
          >
            support@aglow.app
          </GText>
          .
        </GText>
        <GText style={styles.paragraph}>
          your phone number and messaging consent will not be shared with or
          sold to third parties for marketing purposes. we use your phone number
          solely to deliver the messages described above through our messaging
          provider. carriers are not liable for delayed or undelivered messages.
        </GText>

        <GText style={styles.h2}>6. limitation of liability</GText>
        <GText style={styles.paragraph}>
          while we strive to keep aglow running smoothly, we are not responsible
          for any data loss, bugs, or service disruptions that may occur while
          using the app. we disclaim liability for indirect, incidental, or
          consequential damages arising from your use of the app, except in
          cases of gross negligence or intentional misconduct. this limitation
          of liability may not apply in certain jurisdictions where such
          disclaimers are restricted by law.
        </GText>

        <GText style={styles.h2}>7. child safety policy</GText>
        <GText style={styles.paragraph}>
          aglow is intended only for users ages 13 and above. we do not
          knowingly collect personal information from children under 13. if we
          become aware that a user under 13 has provided personal data, we will
          take steps to delete such information. parents or guardians who
          believe their child has provided information without consent can
          contact us to request deletion. inappropriate content or behavior
          targeted at minors is strictly prohibited, and violations may result
          in content removal or account suspension.
        </GText>

        <GText style={styles.h2}>8. changes to terms and services</GText>
        <GText style={styles.paragraph}>
          we may update or change the app, and these terms may also change. we
          will notify you of significant updates by email or in-app
          notification. continued use of aglow after changes are made
          constitutes your acceptance of the updated terms.
        </GText>

        <GText style={styles.h2}>9. account suspension or termination</GText>
        <GText style={styles.paragraph}>
          we reserve the right to suspend or terminate any account that violates
          these terms. grounds for termination include, but are not limited to,
          abusive behavior, illegal content, or repeated violations of our
          community guidelines. if your account is terminated, you may contact
          us to dispute or appeal the decision.
        </GText>

        <GText style={styles.h2}>
          10. governing law and dispute resolution
        </GText>
        <GText style={styles.paragraph}>
          these terms are governed by the laws of california, and any disputes
          will be resolved through mediation or arbitration before escalating to
          legal action. by using aglow, you agree to submit to the jurisdiction
          of the courts in california.
        </GText>

        <GText style={styles.h2}>11. acceptance of terms</GText>
        <GText style={styles.paragraph}>
          by using aglow, you agree to follow these terms and help foster a
          positive community experience. thank you for being a part of aglow!
        </GText>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  h1: {
    color: TEXT_COLOR,
    fontSize: 32,
    fontWeight: "700",
    marginBottom: 24,
    textAlign: "center",
  },
  h2: {
    color: TEXT_COLOR,
    fontSize: 21,
    fontWeight: "600",
    marginBottom: 8,
    marginTop: 24,
    opacity: 0.9,
  },
  link: {
    color: TEXT_COLOR,
    textDecorationLine: "underline",
  },
  logo: {
    height: 30,
    width: 120,
  },
  logoContainer: {
    alignItems: "center",
    marginBottom: 24,
  },
  main: {
    alignSelf: "center",
    maxWidth: 700,
    paddingHorizontal: 16,
    paddingVertical: 32,
    width: "100%",
  },
  nativeContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  nativeText: {
    color: TEXT_COLOR,
    fontSize: 24,
  },
  paragraph: {
    color: TEXT_COLOR,
    fontSize: 16,
    lineHeight: 26,
    marginBottom: 12,
    opacity: 0.85,
  },
  scrollContent: {
    flexGrow: 1,
  },
});
